
import makerjs from "makerjs";
function A17(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    W = Param[0].param,W1 = Param[1].param, H = Param[2].param,
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       h = H * 1 * myZoom,
       w1 = W1 * 1 * myZoom,
       w = W * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       x0 = 0, x1 = w-w1, x2 = w,  y0 = 0, y1 = h, y2 = 0,glassH = h, glassW = w;

   if (h !== 0) {
       var TxtH = H;
   } if (w1 !== 0) {
    var TxtW1 = W1;
}
   if (w !== 0) {
       var TxtW = W;
   }



   var drawAbnormalShapeA17 = {
       paths: {
        "LeftLine": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "RightLine": new makerjs.paths.Line([x1, y1], [x2, y2]),
        "BottomLine": new makerjs.paths.Line([x2, y2], [x0, y0]),
       }
   };
   var drawAbnormalShapeA17MarkW1 = {
       paths: {
        "UpLine": new makerjs.paths.Line([x1, y1 + markShift], [x2, y1 + markShift]),
        "UpShortLfline": new makerjs.paths.Line([x1, y1], [x1, y1 + 2 * markShift]),
        "UpShortRTline": new makerjs.paths.Line([x2, y1], [x2, y1 + 2 * markShift]),
       }
   };
   var drawAbnormalShapeA17MarkH = {
       paths: {
        "RightLine": new makerjs.paths.Line([x2+ markShift, y2], [x2+ markShift, y1]),
        "RightShortUpline": new makerjs.paths.Line([x2, y1], [x2+ 2 * markShift, y1]),
        "RightShortDnline": new makerjs.paths.Line([x2, y2], [x2+ 2 * markShift, y2]),
       }
   };
   var drawAbnormalShapeA17MarkW = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0 - markShift], [x2, y2 - markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x2, y2], [x2, y2 - 2 * markShift]),
       }
  //  };
  
   };
   makerjs.model.addCaption(drawAbnormalShapeA17MarkW, TxtW, [x0, y0 - 2 * markShift], [x2, y2 - 2 * markShift]);//长度文字  
   makerjs.model.addCaption(drawAbnormalShapeA17MarkW1, TxtW1, [x1, y1 + 2 * markShift], [x2, y1 + 2 * markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeA17MarkH, TxtH, [x2 + 2 * markShift, y2], [x2 + 2 * markShift, y1]);//宽度文字
   
  plate={
    models: {
      drawAbnormalShapeA17: drawAbnormalShapeA17,
      }
    };
    markers={
      models: {
        drawAbnormalShapeA17: drawAbnormalShapeA17,
        drawAbnormalShapeA17MarkW1: drawAbnormalShapeA17MarkW1,
        drawAbnormalShapeA17MarkH:drawAbnormalShapeA17MarkH,
        drawAbnormalShapeA17MarkW:drawAbnormalShapeA17MarkW
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default A17;